import React from "react";

import { MonitorStatusDrawerContext, type MonitorStatusDrawerContextValue } from "./_context";

export const MonitorStatusDrawerProvider: React.FC<React.PropsWithChildren<MonitorStatusDrawerContextValue>> = ({
	timestamp,
	timeRange,
	children,
}) => {
	const contextValue = React.useMemo<MonitorStatusDrawerContextValue>(
		() => ({ timestamp, timeRange }),
		[timestamp, timeRange],
	);

	return <MonitorStatusDrawerContext.Provider value={contextValue}>{children}</MonitorStatusDrawerContext.Provider>;
};
